var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 654 656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    display: "none"
  }, /*#__PURE__*/React.createElement("image", {
    width: 546,
    height: 580,
    transform: "translate(-4 1) scale(1.2)",
    xlinkHref: "icon-test-drive-1.png"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.2,399c-2.6-9.5-10.8-21.9-16.6-30.1l-33-46.6c-3.3-4.6-6-9.5-8.3-14.5l-17-38c-8.3-18.5-23.1-33.9-42-43.4-.2-.1-.5-.2-.7-.4-10.2-5-21.3-8.2-32.8-9.5-71.3-8.1-124.2-6.1-124.2-6.1h0c-8.2-.2-58-1.2-123,6.2-11.5,1.3-22.6,4.5-32.8,9.5-.2.1-.5.2-.7.4-19,9.5-33.7,24.9-42,43.4l-17,38c-2.3,5.1-5.1,9.9-8.3,14.5l-33,46.6c-5.8,8.1-14,20.6-16.6,30.1-3.9,14.4-4.3,34.2-3.6,65.5v62.9c0,1.7,0,3.3.4,5,0,.2,0,.4.1.7,5.3,27.2,30.9,46.8,60.5,46.6l216.7-1.1h0c0,0,216.7,1,216.7,1,29.6.1,55.2-19.4,60.5-46.6,0-.2,0-.4.1-.7.3-1.6.4-3.3.4-5v-62.9c.6-31.3.2-51.1-3.7-65.5Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.9,
    y1: 504.1,
    x2: 79.4,
    y2: 504.1,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.8,
    y1: 323.3,
    x2: 109,
    y2: 323.3,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.8,590v28.3c0,6.4-5.3,11.7-11.8,11.7h-53.9c-6.5,0-11.8-5.3-11.8-11.7v-53.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.6,590v28.3c0,6.4,5.3,11.7,11.8,11.7h53.9c6.5,0,11.8-5.3,11.8-11.7v-53.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,396.3l46.2,4.1c1.4.1,2.8.9,3.6,2.1l33.4,44.6c1.3,2-.3,4.7-2.7,4.4l-82.3-12.5c-5.6-.8-10.4-4.2-13.1-9.2s-6-12.4-5.3-16.6c0,0,0-.2,0-.7,1.4-10,10.4-17.1,20.3-16.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.3,396.3l-46.2,4.1c-1.4.1-2.8.9-3.6,2.1l-33.4,44.6c-1.3,2,.3,4.7,2.7,4.4l82.3-12.5c5.6-.8,10.4-4.2,13.1-9.2,2.9-5.4,6-12.4,5.3-16.6,0,0,0-.2,0-.7-1.4-10-10.4-17.1-20.3-16.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7,321.8l-11.2-19.4c-2.9-5-8.9-7.6-14.7-6.4l-30,6.4c-3.5.7-6.1,3.6-6.2,7l-.5,10.2c-.3,4.9,2.8,9.4,7.6,11.2l51.1,15.1,10.9-15.8-6.9-8.3Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.1,321.8l11.2-19.4c2.9-5,8.9-7.6,14.7-6.4l30,6.4c3.5.7,6.1,3.6,6.2,7l.5,10.2c.3,4.9-2.8,9.4-7.6,11.2l-50.5,14-9.9-13.6,5.4-9.5Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.4,405.3l-112.3,8.3-112.3-8.3c-3.6-.3-6.2,3.2-4.7,6.3l17.8,36.6c1.9,3.8,5.8,6.4,10.3,6.7l88.8,6.3h0s0,0,0,0h0s0,0,0,0l88.8-6.3c4.5-.3,8.4-2.9,10.3-6.7l17.8-36.6c1.5-3.1-1.1-6.6-4.7-6.3Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,30.4",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.7,139.6l-20.1-16.9c-.7-.6-1.6-.6-2.3-.2l-23.3,12.6c-1.8,1-3.8-.9-2.9-2.7l10.7-22.5c.4-.9.2-1.9-.5-2.5l-19.5-16.4c-1.6-1.3-.5-3.9,1.6-3.7l26.5,2.6c.9,0,1.7-.4,2.1-1.2l11-23c.9-1.8,3.5-1.5,3.9.4l5.6,24.5c.2.9.9,1.5,1.8,1.6l26.4,2.6c2.1.2,2.6,2.9.8,3.9l-22.8,12.3c-.8.4-1.3,1.4-1,2.3l5.5,24.2c.4,2-1.9,3.4-3.4,2.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.5,81.4l-25.6-7.5c-.8-.2-1.7,0-2.3.7l-15.7,20.6c-1.2,1.6-3.7.7-3.8-1.2l-.3-24.9c0-.9-.6-1.7-1.5-2l-25.2-7.4c-2-.6-2-3.4,0-4l25-7.9c.9-.3,1.5-1.1,1.5-2l-.3-24.9c0-2,2.5-2.9,3.7-1.3l16.1,20.3c.5.7,1.4,1,2.3.7l25.4-8c1.9-.6,3.5,1.6,2.3,3.3l-15.2,20c-.6.8-.6,1.8,0,2.6l15.7,19.7c1.3,1.6-.3,3.9-2.2,3.3Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.9,179.7l-25.6-7.5c-.8-.2-1.7,0-2.3.7l-15.7,20.6c-1.2,1.6-3.7.7-3.8-1.2l-.3-24.9c0-.9-.6-1.7-1.5-2l-25.2-7.4c-2-.6-2-3.4,0-4l25-7.9c.9-.3,1.5-1.1,1.5-2l-.3-24.9c0-2,2.5-2.9,3.7-1.3l16.1,20.3c.5.7,1.4,1,2.3.7l25.4-8c1.9-.6,3.5,1.6,2.3,3.3l-15.2,20c-.6.8-.6,1.8,0,2.6l15.7,19.7c1.3,1.6-.3,3.9-2.2,3.3Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDriveIcon);
export default __webpack_public_path__ + "static/media/test-drive-icon.4eee87f70b24fcf7840a387baadf347a.svg";
export { ForwardRef as ReactComponent };